var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"manage-page_container",attrs:{"id":"ManagePageContainer"}},[_c('Header'),_c('BaseErrorBox'),_c('main',{staticClass:"content",style:(_vm.mainContainerStyle)},[_vm._t("default")],2),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }